import { defineMessages } from 'react-intl';

export const scope = 'app.components.FileDisplayItem';

export default defineMessages({
  file: {
    id: `${scope}.file`,
    defaultMessage: 'File',
  },
});
